import clsApi from '@cls/clsApi'
import clsApiPost from '@cls/clsApiPost'


class clsProjectPlanning extends clsApiPost {

    /**
     * Load the planning for a project
     */
    async loadPlanning(id_project) {
        return this.post(`load`, {id_project}); 
    }

    /**
     * Add an activity to a  the planning for a project
     * When the id of the activity <= 0, replace it by null.
     */
    async saveActivity(model) {
        // We want to remove the negative temporary id's. Do NOT alter model itself. Therefore, copy object.
        var para = {...model}; // no: {id: model.id <= 0 ? null : model.id, ...model} does not work.
        if (para.id <=0) { para.id = null; }
        return this.post(`activity/save`, para);
    }

}
export default clsProjectPlanning;
